import React from "react";

export function Metric({ label, value, color }) {
  return (
    <div className="rounded-2xl bg-[var(--ag7-surface)] border border-[var(--ag7-border-soft)] p-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.03),0_8px_24px_-16px_rgba(0,0,0,0.8)] transition-colors duration-150 hover:border-[var(--ag7-border)]">
      <span className="text-[10px] font-mono text-[var(--ag7-text-muted)] uppercase tracking-wider">{label}</span>
      <h4 className={`text-xl font-extrabold ${color} font-mono mt-1 tabular-nums`}>{value}</h4>
    </div>
  );
}
